import { get } from './generic.api';

export const fetchSourcesByMediaType = async (searchTerm = "", mediaType = "") => {
  try {
    const params = {
      name__icontains: searchTerm,
      is_active: true,
    };

    if (mediaType) {
      params.source_type = mediaType;
    }

    const response = await get(`/clients/intranet/source/`, params);

    return response.map((source) => ({
      value: source.id,
      label: source.name,
    }));
  } catch (error) {
    console.error('Erro ao buscar veículos:', error.response);
    throw error;
  }
};